module.exports = __webpack_public_path__ + "c6bca9233b0e74c5f21c94c02cd9544b.fbx";